export const PATH_TO_IMAGES = "/punto/build/images/";
